import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent {
  constructor(private router: Router) {}

  scrollToElement(fragmentId: string) {
    // Timeout ensures scroll after navigation
    setTimeout(() => {
      const el = document.getElementById(fragmentId);
      if (el) {
        // Get the header height - adjusted to show section titles properly
        const headerHeight = 120; // Fixed header height + padding for title visibility
        const elementPosition = el.offsetTop - headerHeight;
        
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }, 300);
  }

  onComoFuncionaClick(event: Event) {
    this.router.navigate(['/'], { fragment: 'como-funciona-section' });
    this.scrollToElement('como-funciona-section');
  }

  onTuEligesClick(event: Event) {
    this.router.navigate(['/'], { fragment: 'tu-eliges-section' });
    this.scrollToElement('tu-eliges-section');
  }

  onSuscribirseClick(event: Event) {
    this.router.navigate(['/'], { fragment: 'footer-subscribe-form' });
    this.scrollToElement('footer-subscribe-form');
  }
}
